export const getUrlParams = (): any => {
  // 截取url中的code方法
  const url = location.search;
  const theRequest: any = {};

  if (url.indexOf("?") != -1) {
    const str = url.substr(1);
    const strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
    }
  }
  return theRequest;
};

export const isWeixin = (): any => {
  const ua: any = navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

export const openDefaultBrowser = (url: string) => {
  if (window.wx && window.wx.invoke) {
    window.wx.invoke('openDefaultBrowser', {
      url,
    }, function(res: any) {
      if (res.err_msg != "openDefaultBrowser:ok") {
        //错误处理
      }
    });
  } else {
    window.open(url, '_blank');
  }
}

export const copyToClipboard = (content: string) => {
  const textarea = document.createElement('textarea');

  textarea.value = content;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  
  document.body.removeChild(textarea);
}

export const imgTypeCheck = (data: Blob | File) => {
  if (Object.prototype.toString.call(data).toLowerCase() === '[object blob]') {
    return true;
  }

  // File类型，判断下和名称和后缀匹配不
  const matches = data.type.match(/^image\/(.*)$/);
  let type = '';

  if (matches) {
    type = matches[1];

    if (type === 'jpeg') {
      type = 'jpg|jpeg';
    }

    return (data as File).name.match(new RegExp(`\\.${type}$`));
  }

  return false;
}

export const getParseQuery = (link: string) => {
  const urlObj = new URL(link);
  const urlSearchParams = urlObj.searchParams;
  const paramObj = Object.fromEntries(urlSearchParams);

  return paramObj;
}

export const isMobile = () => {
  if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|huawei|honor|vivo|oppo|MiuiBrowser)/i)) {
    return true;
  } else {
    return false;
  }
}
